import avatarModule from '../avatarModule';

function avatarConstantService(languageResource) {
  'ngInject';

  const lang = languageResource;
  return {
    events: {
      avatarDetailsLoaded: 'Roblox.Avatar.AvatarDetailsLoaded',
      avatarRulesLoaded: 'Roblox.Avatar.AvatarRulesLoaded',
      menuClicked: 'Roblox.Avatar.MenuClicked',
      outfitsChanged: 'Roblox.Avatar.OutfitsChanged',
      outfitDeleted: 'Roblox.Avatar.OutfitDeleted',
      wornAssetsChanged: 'Roblox.Avatar.WornAssetsChanged',
      metaDataLoaded: 'Roblox.Avatar.MetaDataLoaded',
      bodyColorsChanged: 'Roblox.Avatar.BodyColorsChanged',
      pageLoaded: 'Roblox.Avatar.PageLoaded'
    },
    page: {
      errorLoadingPage: lang.get('Message.PageUnavailable'),
      idleRefreshTimeInSeconds: 10
    },
    tabs: [
      {
        label: lang.get('Heading.Recent'),
        name: 'Recent',
        subCategoryMenu: [
          { name: 'All', label: lang.get('Heading.All') },
          { name: 'Accessories', label: lang.get('Heading.Accessories') },
          { name: 'Clothing', label: lang.get('Heading.Clothing') },
          { name: 'BodyParts', label: lang.get('Heading.BodyParts') },
          { name: 'AvatarAnimations', label: lang.get('Heading.Animations') },
          { name: 'Outfits', label: lang.get('Heading.Outfits') }
        ]
      },
      {
        label: lang.get('Heading.Clothing'),
        name: 'Clothing',
        tabType: 'Assets',
        menuType: 'Nested',
        categoryRows: [
          {
            title: lang.get('Heading.Accessories'),
            name: 'Accessories',
            subCategoryMenu: [
              {
                name: 'Hats',
                label: lang.get('Label.Hat'),
                fullLabel: lang.get('Label.HatAccessories'),
                assetType: 'Hat'
              },
              {
                name: 'Hair',
                label: lang.get('Label.Hair'),
                fullLabel: lang.get('Label.HairAccessories'),
                assetType: 'Hair Accessory'
              },
              {
                name: 'Face',
                label: lang.get('Label.Face'),
                fullLabel: lang.get('Label.FaceAccessories'),
                assetType: 'Face Accessory'
              },
              {
                name: 'Neck',
                label: lang.get('Label.Neck'),
                fullLabel: lang.get('Label.NeckAccessories'),
                assetType: 'Neck Accessory'
              },
              {
                name: 'Shoulder',
                label: lang.get('Label.Shoulders'),
                fullLabel: lang.get('Label.ShoulderAccessories'),
                assetType: 'Shoulder Accessory'
              },
              {
                name: 'Front',
                label: lang.get('Label.Front'),
                fullLabel: lang.get('Label.FrontAccessories'),
                assetType: 'Front Accessory'
              },
              {
                name: 'Back',
                label: lang.get('Label.Back'),
                fullLabel: lang.get('Label.BackAccessories'),
                assetType: 'Back Accessory'
              },
              {
                name: 'Waist',
                label: lang.get('Label.Waist'),
                fullLabel: lang.get('Label.WaistAccessories'),
                assetType: 'Waist Accessory'
              }
            ]
          },
          {
            title: lang.get('Label.Clothes'),
            name: 'Clothing',
            subCategoryMenu: [
              { name: 'Shirts', label: lang.get('Label.Shirts'), assetType: 'Shirt' },
              { name: 'Pants', label: lang.get('Label.Pants'), assetType: 'Pants' },
              { name: 'T-Shirts', label: lang.get('Label.TShirts'), assetType: 'T-Shirt' }
            ]
          },
          {
            title: lang.get('Label.Gear'),
            name: 'Gear',
            subCategoryMenu: [{ name: 'Gear', label: lang.get('Label.Gear'), assetType: 'Gear' }]
          }
        ]
      },
      {
        label: lang.get('Heading.Body'),
        name: 'Body',
        tabType: 'Assets',
        menuType: 'Nested',
        categoryRows: [
          {
            title: lang.get('Label.Parts'),
            name: 'BodyParts',
            subCategoryMenu: [
              {
                name: 'Face',
                label: lang.get('Label.Face'),
                assetType: 'Face',
                fullLabel: lang.get('Label.Faces')
              },
              {
                name: 'Head',
                label: lang.get('Label.Head'),
                assetType: 'Head',
                fullLabel: lang.get('Label.Heads')
              },
              {
                name: 'Torso',
                label: lang.get('Label.Torso'),
                assetType: 'Torso',
                fullLabel: lang.get('Label.Torsos')
              },
              {
                name: 'LeftArms',
                label: lang.get('Label.LeftArms'),
                assetType: 'Left Arm',
                fullLabel: lang.get('Label.LeftArms')
              },
              {
                name: 'RightArms',
                label: lang.get('Label.RightArms'),
                assetType: 'Right Arm',
                fullLabel: lang.get('Label.RightArms')
              },
              {
                name: 'LeftLegs',
                label: lang.get('Label.LeftLegs'),
                assetType: 'Left Leg',
                fullLabel: lang.get('Label.LeftLegs')
              },
              {
                name: 'RightLegs',
                label: lang.get('Label.RightLegs'),
                assetType: 'Right Leg',
                fullLabel: lang.get('Label.RightLegs')
              }
            ]
          },
          {
            title: lang.get('Heading.Appearance'),
            name: 'Appearance',
            subCategoryMenu: [
              { name: 'BodyColors', label: lang.get('Label.SkinTone') },
              { name: 'Scale', label: lang.get('Label.Scale'), visible: false }
            ]
          },
          {
            title: lang.get('Heading.Packages'),
            name: 'Packages',
            subCategoryMenu: [
              {
                name: 'Package',
                label: lang.get('Heading.Packages'),
                assetType: 'Package',
                fullLabel: lang.get('Heading.Packages')
              }
            ]
          }
        ]
      },
      {
        label: lang.get('Heading.Animations'),
        name: 'AvatarAnimations',
        tabType: 'Assets',
        subCategoryMenu: [
          {
            name: 'Emote',
            label: lang.get('Heading.Emotes'),
            fullLabel: lang.get('Heading.Emotes'),
            assetType: 'Emote Animation',
            visible: false
          },
          {
            name: 'Walk',
            label: lang.get('Label.Walk'),
            fullLabel: lang.get('Label.WalkAnimations'),
            assetType: 'Walk Animation'
          },
          {
            name: 'Run',
            label: lang.get('Label.Run'),
            fullLabel: lang.get('Label.RunAnimations'),
            assetType: 'Run Animation'
          },
          {
            name: 'Fall',
            label: lang.get('Label.Fall'),
            fullLabel: lang.get('Label.FallAnimations'),
            assetType: 'Fall Animation'
          },
          {
            name: 'Jump',
            label: lang.get('Label.Jump'),
            fullLabel: lang.get('Label.JumpAnimations'),
            assetType: 'Jump Animation'
          },
          {
            name: 'Swim',
            label: lang.get('Label.Swim'),
            fullLabel: lang.get('Label.SwimAnimations'),
            assetType: 'Swim Animation'
          },
          {
            name: 'Climb',
            label: lang.get('Label.Climb'),
            fullLabel: lang.get('Label.ClimbAnimations'),
            assetType: 'Climb Animation'
          },
          {
            name: 'Idle',
            label: lang.get('Label.Idle'),
            fullLabel: lang.get('Label.IdleAnimations'),
            assetType: 'Idle Animation'
          }
        ]
      },
      {
        label: lang.get('Heading.Outfits'),
        name: 'Outfits',
        tabType: 'Outfits',
        subCategoryMenu: [],
        noSubCategoryMenu: true,
        visible: true
      },
      {
        label: lang.get('Heading.Costumes'),
        name: 'Costumes',
        tabType: 'Costumes',
        visible: false,
        subCategoryMenu: [
          {
            name: 'PresetCostumes',
            label: lang.get('Label.PresetCostumes'),
            fullLabel: lang.get('Label.PresetCostumes')
          },
          {
            name: 'MyCostumes',
            label: lang.get('Label.MyCostumes'),
            fullLabel: lang.get('Label.MyCostumes')
          }
        ]
      }
    ],
    thumbnail: {
      redrawFloodchecked: lang.get('Message.RedrawFloodchecked'),
      redrawThumbnailFailed: lang.get('Message.RedrawThumbnailFailed'),
      waitForThumbnailRegenerationInSeconds: 30,
      useThreeDeeThumbsKey: "RobloxUse3DThumbnailsV2",
      threeDeeButton: lang.get('Action.ThreeDimensions'),
      twoDeeButton: lang.get('Action.TwoDimensions'),
    },
    recent: {
      couldNotLoadList: lang.get('Message.FailedLoadRecent'),
      emptyMessage: lang.get('Message.EmptyRecentItems')
    },
    outfits: {
      createNewOutfit(outfitType) {
        if (outfitType === 'Outfit') {
          return lang.get('Heading.CreateNewOutfit');
        } else {
          return lang.get('Heading.CreateNewCostume');
        }
      },
      outfitMessages: {
        // TODO: once Costumes/bundles are official, then refactor. See AV-2083.
        renameOutfitTitle: lang.get('Heading.RenameOutfit'),
        renameOutfitDescription: lang.get('Description.RenameOutfit'),
        renameOutfitButton: lang.get('Action.Rename'), // same string value in both outfit and costume
        createOutfitTitle: lang.get('Heading.CreateNewOutfit'),
        createOutfitDescription: lang.get('Description.CreateNewOutfit'),
        createOutfitButton: lang.get('Action.CreateNewOutfit'), // same string value in both outfit and costume
        successfulRename: lang.get('Message.SuccessRenameOutfit'),
        successfulDelete: lang.get('Message.SuccessDeleteOutfit'),
        successfulUpdate: lang.get('Message.SuccessUpdatedOutfit'),
        successfulCreate: lang.get('Message.SuccessCreateOutfit'),
        successfulWear: lang.get('Message.SuccessWoreOutfit'),
        emptyMessage: lang.get('Message.EmptyListOfOutfits'),
        maxNumberOfOutfits: lang.get('Message.ReachedMaxOutfits'),
        errorCreatingOutfit: lang.get('Message.ErrorCreateOutfit'),
        invalidOutfitName: lang.get('Message.InvalidOutfitName'), // same string value in both outfit and costume
        updateFailedOutfitDelete: lang.get('Message.FailedUpdateDeletedOutfit'),
        errorUpdatingOutfit: lang.get('Message.ErrorUpdateOutfit'),
        errorDeletingOutfit: lang.get('Message.FailedDeleteOutfit'),
        errorRenamingOutfit: lang.get('Message.ErrorRenameOutfit'),
        errorWearingOutfit: lang.get('Message.ErrorWearOutfit'),
        failedToLoadOutfits: lang.get('Message.ErrorLoadOutfits'),
        nameInputPlaceholder: lang.get('Label.NamePlaceholderOutfit')
      },
      costumeMessages: {
        renameOutfitTitle: lang.get('Heading.RenameCostume'),
        renameOutfitDescription: lang.get('Description.RenameCostume'),
        renameOutfitButton: lang.get('Action.Rename'), // same string value in both outfit and costume
        createOutfitTitle: lang.get('Heading.CreateNewCostume'),
        createOutfitDescription: lang.get('Description.CreateNewCostume'),
        createOutfitButton: lang.get('Action.CreateNewOutfit'), // same string value in both outfit and costume
        successfulRename: lang.get('Message.SuccessRenameCostume'),
        successfulDelete: lang.get('Message.SuccessDeleteCostume'),
        successfulUpdate: lang.get('Message.SuccessUpdatedCostume'),
        successfulCreate: lang.get('Message.SuccessCreateCostume'),
        successfulWear: lang.get('Message.SuccessWoreCostume'),
        emptyMessage: lang.get('Message.EmptyListOfCostumes'),
        maxNumberOfOutfits: lang.get('Message.ReachedMaxCostumes'),
        errorCreatingOutfit: lang.get('Message.ErrorCreateCostume'),
        invalidOutfitName: lang.get('Message.InvalidOutfitName'), // same string value in both outfit and costume
        updateFailedOutfitDelete: lang.get('Message.FailedUpdateDeletedCostume'),
        errorUpdatingOutfit: lang.get('Message.ErrorUpdateCostume'),
        errorDeletingOutfit: lang.get('Message.FailedDeleteCostume'),
        errorRenamingOutfit: lang.get('Message.ErrorRenameCostume'),
        errorWearingOutfit: lang.get('Message.ErrorWearCostume'),
        failedToLoadOutfits: lang.get('Message.ErrorLoadCostume'),
        nameInputPlaceholder: lang.get('Label.NamePlaceholderCostume')
      },
      countNumbersInEnglish: ['zero', 'one', 'two', 'three', 'four', 'five'],
      missingItemsFromOutfit(count) {
        return lang.get('Message.MissingItemsFromOutfit', { number: count });
      },
      menuOptions: [
        { label: lang.get('Action.Update'), name: 'Update' },
        { label: lang.get('Action.Rename'), name: 'Rename' },
        { label: lang.get('Action.Delete'), name: 'Delete' },
        { label: lang.get('Action.Cancel'), name: 'Cancel' }
      ],
      outfitErrorCodes: {
        maxOutfits: 1,
        invalidBodyColors: 3,
        invalidOutfitName: 4,
        unwearableAsset: 5,
        internalError: 6
      }
    },
    packages: {
      errorWearingPackage: lang.get('Message.FailedWearPackage')
    },
    assets: {
      savedAdvancedAccessories: lang.get('Message.SuccessSavedAccessories'),
      emptyMessage(type) {
        return lang.get('Message.EmptyListForItem', { itemType: type });
      },
      couldNotLoadList: lang.get('Message.FailedLoadAssets'),
      errorUpdatingItems: lang.get('Message.ErrorUpdateWorn'),
      maxAccessories: 10
    },
    scales: {
      failedToUpdate: lang.get('Message.FailedUpdateScales')
    },
    avatarType: {
      failedToUpdate: lang.get('Message.FailedUpdateType'),
      defaultOnPageLoad: 'R15',
      avatarTypes: ['R6', 'R15']
    },
    bodyColors: {
      failedToUpdate: lang.get('Message.FailedUpdateBodyColor'),
      palette: [
        { brickColorId: 364, hexColor: '#5A4C42' },
        { brickColorId: 217, hexColor: '#7C5C46' },
        { brickColorId: 359, hexColor: '#AF9483' },
        { brickColorId: 18, hexColor: '#CC8E69' },
        { brickColorId: 125, hexColor: '#EAB892' },
        { brickColorId: 361, hexColor: '#564236' },
        { brickColorId: 192, hexColor: '#694028' },
        { brickColorId: 351, hexColor: '#BC9B5D' },
        { brickColorId: 352, hexColor: '#C7AC78' },
        { brickColorId: 5, hexColor: '#D7C59A' },
        { brickColorId: 153, hexColor: '#957977' },
        { brickColorId: 1007, hexColor: '#A34B4B' },
        { brickColorId: 101, hexColor: '#DA867A' },
        { brickColorId: 1025, hexColor: '#FFC9C9' },
        { brickColorId: 330, hexColor: '#FF98DC' },
        { brickColorId: 135, hexColor: '#74869D' },
        { brickColorId: 305, hexColor: '#527CAE' },
        { brickColorId: 11, hexColor: '#80BBDC' },
        { brickColorId: 1026, hexColor: '#B1A7FF' },
        { brickColorId: 321, hexColor: '#A75E9B' },
        { brickColorId: 107, hexColor: '#008F9C' },
        { brickColorId: 310, hexColor: '#5B9A4C' },
        { brickColorId: 317, hexColor: '#7C9C6B' },
        { brickColorId: 29, hexColor: '#A1C48C' },
        { brickColorId: 105, hexColor: '#E29B40' },
        { brickColorId: 24, hexColor: '#F5CD30' },
        { brickColorId: 334, hexColor: '#F8D96D' },
        { brickColorId: 199, hexColor: '#635F62' },
        { brickColorId: 1002, hexColor: '#CDCDCD' },
        { brickColorId: 1001, hexColor: '#F8F8F8' }
      ]
    },
    bodyParts: {
      all: lang.get('Label.All'),
      head: lang.get('Label.Head'),
      torso: lang.get('Label.Torso'),
      leftArm: lang.get('Label.LeftArm'),
      rightArm: lang.get('Label.RightArm'),
      leftLeg: lang.get('Label.LeftLeg'),
      rightLeg: lang.get('Label.RightLeg')
    },
    bodyScaling: {
      height: lang.get('Label.Height'),
      width: lang.get('Label.Width'),
      head: lang.get('Label.Head'),
      bodyType: lang.get('Label.BodyType'),
      proportions: lang.get('Label.Proportions')
    },
    bodyScalingType: {
      height: 'Height',
      width: 'Width',
      head: 'Head',
      bodyType: 'BodyType',
      proportions: 'Proportions'
    },
    googleAnalytics: {
      category: 'AvatarPage',
      advancedAccessoriesAction: 'AdvancedAccessories',
      advancedBodyColorsAction: 'AdvancedBodyColors',
      openLabel: 'Open',
      closeLabel: 'Close',
      saveLabel: 'Save',
      saveFailedLabel: 'SaveFailed'
    },
    defaultClothing: {
      wearClothing: lang.get('Message.DefaultClothing'),
      displayTimeInMilliseconds: 5000
    },
    modalLayout: {
      outfitUpdate: {
        titlePrefix(outfitType) {
          if (outfitType === 'Outfit') {
            return lang.get('Heading.UpdateOutfit');
          } else {
            return lang.get('Heading.UpdateCostume');
          }
        },
        bodyText(outfitType) {
          if (outfitType === 'Outfit') {
            return lang.get('Message.UpdateThisOutfit');
          } else {
            return lang.get('Message.UpdateThisCostume');
          }
        },
        confirmBtnName: lang.get('Action.Update'),
        cancelBtnName: lang.get('Action.Cancel'),
        confirmBtnId: 'purchaseConfirm'
      },
      outfitDelete: {
        titlePrefix(outfitType) {
          if (outfitType === 'Outfit') {
            return lang.get('Heading.DeleteOutfit');
          } else {
            return lang.get('Heading.DeleteCostume');
          }
        },
        bodyText(outfitType) {
          if (outfitType === 'Outfit') {
            return lang.get('Message.DeleteThisOutfit');
          } else {
            return lang.get('Message.DeleteThisCostume');
          }
        },
        confirmBtnName: lang.get('Action.Delete'),
        cancelBtnName: lang.get('Action.Cancel'),
        confirmBtnId: 'purchaseConfirm'
      },
      advancedAccessoriesDoubleCheck: {
        title: lang.get('Heading.AccessoriesChange'),
        bodyText: lang.get('Message.AccessoriesChange'),
        confirmBtnName: lang.get('Action.Save'),
        cancelBtnName: lang.get('Action.Cancel')
      }
    },
    emotes: {
      assetType: 'Emote Animation',
      emotesInstructions: lang.get('Message.EmotesInstructions'),
      successfulDelete: lang.get('Message.SuccessUnequipEmote'),
      successfulUpdate: lang.get('Message.SuccessEquipEmote'),
      errorUpdatingEmote: lang.get('Message.ErrorEquipEmote'),
      errorDeletingEmote: lang.get('Message.ErrorDeleteEmote'),
      errorGettingEmotes: lang.get('Message.ErrorLoadEmotes')
    }
  };
}

avatarModule.factory('avatarConstantService', avatarConstantService);

export default avatarConstantService;
